import React from 'react';

import { GqlDispensaries } from 'types/graphql';

import { DesktopHeader } from './desktop-header';
import { MobileHeader } from './mobile-header';
import { InfoBar } from './info-bar';
import { DesktopMq, InfoBarMq, MobileMq } from './header.styles';

type NavigationProps = {
  dispensary: GqlDispensaries;
  isAccountEnabled: boolean;
};

export const Navigation = ({ dispensary, isAccountEnabled }: NavigationProps): JSX.Element => (
  <>
    <DesktopMq>
      <DesktopHeader dispensary={dispensary} isAccountEnabled={isAccountEnabled} />
    </DesktopMq>

    <MobileMq>
      <MobileHeader dispensary={dispensary} isAccountEnabled={isAccountEnabled} />
    </MobileMq>

    <InfoBarMq>
      <InfoBar />
    </InfoBarMq>
  </>
);
